import hku from "./universities/hku.png";
import ust from "./universities/ust.png";
import cuhk from "./universities/cuhk.png";
import polyu from "./universities/polyu.png";
import bu from "./universities/bu.png";
import cityu from "./universities/cityu.png";
import eduu from "./universities/eduu.png";
import hksyu from "./universities/hksyu.png";
import hkmu from "./universities/hkmu.png";
import lingu from "./universities/lingu.png";
import hkuspace from "./universities/hkuspace.png";
import twCsmu from "./universities/tw_csmu.png";

export type University = {
  value: string;
  label: string;
  image: string;
};

/**
 * University list mirroring the RN app. Display names come from the
 * translation keys (e.g. `t("hku")`); `label` is a plain-English fallback.
 * Logos are the real university marks bundled from the RN app assets.
 */
export const universityList: University[] = [
  { value: "hku", label: "University of Hong Kong", image: hku },
  { value: "hkust", label: "HKUST", image: ust },
  { value: "cuhk", label: "The Chinese University of Hong Kong", image: cuhk },
  { value: "polyu", label: "The Hong Kong Polytechnic University", image: polyu },
  { value: "hkbu", label: "Hong Kong Baptist University", image: bu },
  { value: "cityu", label: "City University of Hong Kong", image: cityu },
  { value: "eduhk", label: "The Education University of Hong Kong", image: eduu },
  { value: "hksyu", label: "Hong Kong Shue Yan University", image: hksyu },
  { value: "hkmu", label: "Hong Kong Metropolitan University", image: hkmu },
  { value: "lingu", label: "Lingnan University", image: lingu },
  { value: "hkuspace", label: "HKU Space", image: hkuspace },
  { value: "tw_csmu", label: "Chung Shan Medical University", image: twCsmu },
];